import React from "react";
import { AdminRoute } from "../../AdminRoute";
import DocumentationPage from "../DocumentationPage";

export const Documentation: React.FC = () => {
    return (
        <AdminRoute>
            <DocumentationPage />
        </AdminRoute>
    );
}; 